function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

function getGlobalDomain(url) {
    const endsWithSlash = Shopify.routes.root.endsWith('/');
    const root = endsWithSlash ? Shopify.routes.root.slice(0, -1) : Shopify.routes.root;
    return `${root}${url}`;
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        'focus',
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

class Favourites {
    constructor() {
        this.itemsToChange = [];
        this.favouriteProducts = this.getFavourites();

        this.debouncedOnChange = debounce((event) => {
            this.syncEndpoint();
        }, 1000);

        this.fetchFavourites();
    }

    getFavourites() {
        const retrieved = localStorage.getItem(LOCAL_STORAGE_FAVOURITES_KEY) ?? null;
        return retrieved ? JSON.parse(retrieved) : [];
    }

    setFavourites() {
        localStorage.setItem(LOCAL_STORAGE_FAVOURITES_KEY, JSON.stringify(this.favouriteProducts));
    }

    removeFavourite(handle) {
        favouriteClass.favouriteProducts.splice(favouriteClass.favouriteProducts.indexOf(handle), 1);
        this.setFavourites();
    }

    addFavourite(handle) {
        this.favouriteProducts.push(handle);
        this.setFavourites();
    }

    syncEndpoint() {
        const itemsToRemove = this.itemsToChange.filter((item) => item.action === 'remove');
        const itemsToAdd = this.itemsToChange.filter((item) => item.action === 'add');

        if (itemsToRemove.length > 0)
            this.fetchEndpoint(getGlobalDomain('/apps/bat-enhanced/customer/favourites/remove'), [
                ...itemsToRemove.map((item) => item.handle),
            ]);

        if (itemsToAdd.length > 0)
            this.fetchEndpoint(getGlobalDomain('/apps/bat-enhanced/customer/favourites/add'), [
                ...itemsToAdd.map((item) => item.handle),
            ]);
    }

    fetchCallback(data) {
        if (data.ok) {
            if (data.productHandles) {
                this.itemsToChange = [];
                document.dispatchEvent(new CustomEvent('favoritesUpdated', { bubbles: true, composed: true }));
            }
        } else {
            throw new Error(data.message || 'Unknown error during favourites update');
        }
    }

    async fetchEndpoint(endpoint, payload) {
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            this.fetchCallback(data);
        } catch (error) {
            console.error(`[Favourites] Failed to ${endpoint} favourite on server:`, error);

            this.favouriteIcon.classList.toggle('favourites__icon--active', action === 'remove');
        }
    }

    async fetchFavourites() {
        const favourites = this.getFavourites();
        try {
            const response = await fetch(getGlobalDomain('/apps/bat-enhanced/customer/favourites/sync'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ handles: favourites }),
            });
            const data = await response.json();
            if (data.ok && data.productHandles) {
                this.favouriteProducts = data.productHandles;
                this.setFavourites();
            } else {
                console.error('Error syncing favorites:', data.message || 'Unknown error');
            }
        } catch (error) {
            console.error('Failed to sync favorites:', error);
        }
    }
}

const favouriteClass = new Favourites();

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class CartQuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input') ? this.querySelector('input') : this.querySelector('select');
        this.manualUpdateButton = this.querySelector('.quantity-input__update');
        this.changeEvent = new Event('change', { bubbles: true });
        if (this.input.tagName === 'SELECT') {
            this.input.addEventListener('change', this.onInputChange.bind(this));
        } else {
            if (!this.manualUpdateButton) return;
            this.manualUpdateButton.addEventListener('click', this.manualUpdate.bind(this));
        }
        this.querySelectorAll('button:not(.quantity-input__update)').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (this.select) this.renderSelect();
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = addAnalyticsEvents(
            USER_INTERACTION_ANALYTICS_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this)
        );
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    manualUpdate(event) {
        event.preventDefault();
        this.input.dispatchEvent(new Event('manual-change', { bubbles: true }));
    }

    generateButton() {
        const button = document.createElement('BUTTON');
        button.textContent = window.cartStrings.update;
        button.type = 'button';
        button.classList.add(...['button', 'button--small']);
        button.addEventListener('click', this.manualUpdate.bind(this));
        return button;
    }

    generateInput(select) {
        if (!select) return;
        const attributes = select.attributes;
        const input = document.createElement('INPUT');
        input.setAttribute('type', 'number');
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            input.setAttribute(attribute.name, attribute.value);
        }
        input.classList.add('quantity-input--manual');
        this.input = input;
        return input;
    }

    onSelectChange(event) {
        const value = event.target.value;
        if (value === '10+') {
            event.target.replaceWith(...[this.generateInput(event.target), this.generateButton()]);
        }
    }

    onInputChange(event) {
        if (event.target.tagName === 'SELECT') {
            this.onSelectChange(event);
        } else {
            this.validateQtyRules();
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        this.dispatchChange(() => {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        });
    }

    dispatchChange(changeFunction) {
        const previousValue = this.input.value;
        if (changeFunction) changeFunction();

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if (!buttonMinus || !buttonPlus) return;
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('cart-quantity-input', CartQuantityInput);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input') ? this.querySelector('input') : this.querySelector('select');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (this.select) this.renderSelect();
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = addAnalyticsEvents(
            USER_INTERACTION_ANALYTICS_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this)
        );
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    generateInput(select) {
        if (!select) return;
        const attributes = select.attributes;
        const input = document.createElement('INPUT');
        input.setAttribute('type', 'number');
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            input.setAttribute(attribute.name, attribute.value);
        }
        return input;
    }

    onSelectChange(event) {
        const value = event.target.value;
        if (value === '10+') {
            event.target.replaceWith(this.generateInput(event.target));
        }
    }

    onInputChange(event) {
        if (event.target.tagName === 'SELECT') {
            this.onSelectChange(event);
        } else {
            this.validateQtyRules();
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        this.dispatchChange(() => {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        });
    }

    dispatchChange(changeFunction) {
        const previousValue = this.input.value;
        if (changeFunction) changeFunction();

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if (!buttonMinus || !buttonPlus) return;
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
            button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

            if (window.matchMedia('(max-width: 990px)')) {
                document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle, false);

        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    }

    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(this.header.getBoundingClientRect().bottom)}px`
        );
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        window.addEventListener('resize', this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        this.header &&
            document.documentElement.style.setProperty(
                '--header-bottom-position',
                `${parseInt(this.header.getBoundingClientRect().bottom)}px`
            );
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.sectionId = this.id.replace('PopupModal-', '');
        this.localStorageKey = `${this.sectionId}_popup_shown`;

        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.setupAutoTrigger();
        this.setupTriggerButtonListener();
    }

    setupAutoTrigger() {
        const modalContent = this.querySelector('.modal-popup__content');
        if (modalContent) {
            const autoTriggerTime = parseInt(modalContent.dataset.autoTriggerTime);
            const storeSession = modalContent.dataset.storeSession === 'true';
            const hasSessionStored = localStorage.getItem(this.localStorageKey) === 'true';

            if (
                autoTriggerTime &&
                autoTriggerTime !== null &&
                autoTriggerTime !== undefined &&
                autoTriggerTime !== NaN &&
                (!storeSession || !hasSessionStored)
            ) {
                this.autoTrigger(autoTriggerTime);
            }
        }
    }

    setupTriggerButtonListener() {
        const modalContent = this.querySelector('.modal-popup__content');
        if (modalContent) {
            const triggerSelector = modalContent.dataset.triggerClass;
            if (triggerSelector) {
                const triggerElements = document.querySelectorAll(triggerSelector);
                triggerElements.forEach((element) => {
                    element.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.show();
                    });
                });
            }
        }
    }

    show(opener) {
        this.isOpen = true;
        const modalContent = this.querySelector('.modal-popup__content');
        const storeSession = modalContent && modalContent.dataset.storeSession === 'true';

        if (storeSession) {
            localStorage.setItem(this.localStorageKey, 'true');
        }

        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        this.isOpen = false;
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }

    autoTrigger(delay) {
        setTimeout(() => {
            this.show();
        }, delay);
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal.isOpen) {
                button.classList.remove('open');
                modal.hide();
            } else {
                button.classList.add('open');
                modal.show(button);
            }
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class TinySliderConfig {
    generateConfig(element) {
        this.hasNav = element.querySelectorAll('.tiny-slider__nav').length > 0;
        this.navElm = element.querySelector('.tiny-slider__nav');
        this.hasDirectorButtons = element.querySelectorAll('.tiny-slider__buttons').length > 0;
        this.directorButtons = element.querySelectorAll('.tiny-slider__buttons button');
        this.sliderElm = element.querySelector('.tiny-slider__slides');
        this.settingsTemplate = element.querySelector('script[type="text/template"]');
        this.settings = this.settingsTemplate ? JSON.parse(this.settingsTemplate.innerHTML) : undefined;
        this.prevButton = element.querySelector('.slider-button--prev') ?? undefined;
        this.nextButton = element.querySelector('.slider-button--next') ?? undefined;
        this.navContainer = element.querySelector('.tiny-slider-counter') ?? undefined;
        return {
            ...this.settings,
            container: this.sliderElm,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            navContainer: this.navContainer,
            preventScrollOnTouch: 'auto',
            onInit: this.onInit(),
            navElm: this.navElm,
            hasNav: this.hasNav,
            sliderDirectorButtonsExist: this.hasDirectorButtons,
            sliderDirectorButtons: this.directorButtons,
        };
    }

    onInit() {
        if (this.settings?.mouseDrag) this.sliderElm?.classList.add('tns-mouse-drag');
    }
}

class TinySlider extends HTMLElement {
    constructor() {
        super();
        this.config = new TinySliderConfig().generateConfig(this);

        if (this.config.hasNav) {
            if (this.config.navContainer) {
                this.thumbnails = undefined;
                this.thumbnailCheck();
            } else {
                this.slider = tns({
                    ...this.config,
                    navContainer: this.config.navElm,
                    navAsThumbnails: this.config.hasNav,
                });
            }
        } else {
            this.slider = tns(this.config);
        }

        const useDirectorButtons = this.hasDirectorButtons || this.config.sliderDirectorButtonsExist;
        if (useDirectorButtons) {
            this.slider.events.on('transitionEnd', this.onTransitionEnd.bind(this));
            if (this.directorButtons && this.directorButtons.length > 0) {
                this.directorButtons.forEach((button) =>
                    button.addEventListener('click', this.directorClick.bind(this))
                );
            } else if (this.config.sliderDirectorButtons && this.config.sliderDirectorButtons.length > 0) {
                this.config.sliderDirectorButtons.forEach((button) =>
                    button.addEventListener('click', this.directorClick.bind(this))
                );
            }
        }

        this.onInit();
    }

    onInit() {
        this.initThumbnails(this);
        this.initAriaCheck(this);

        this.slider.events.on('indexChanged', this.initAriaCheck.bind(this));
    }

    initAriaCheck() {
        const { slideItems } = this.slider.getInfo();

        if (slideItems)
            [...slideItems].forEach((slide) => {
                const allInputs = slide.querySelectorAll('input, button');
                if (slide.classList.contains('tns-slide-active')) {
                    [...allInputs].forEach((input) => {
                        input.removeAttribute('aria-disabled');
                    });
                } else {
                    [...allInputs].forEach((input) => {
                        input.setAttribute('aria-disabled', 'true');
                    });
                }
            });
    }

    initThumbnails() {
        if (!this.config.hasNav) return;

        this.navSettingsTemplate = this.querySelector('.tiny-slider__nav-script');
        this.navSettings = this.navSettingsTemplate ? JSON.parse(this.navSettingsTemplate.innerHTML) : undefined;

        if (this.thumbnails) {
            this.thumbnails.rebuild();
        } else {
            this.thumbnails = tns({
                ...this.navSettings,
                container: this.config.navElm,
            });

            this.slider.events.on('indexChanged', this.thumbnailsOnChange.bind(this));
            this.thumbnails.events.on('indexChanged', this.thumbnailsOnChange.bind(this));
        }
    }

    thumbnailsOnChange(event) {
        if (this.slider.getInfo().index != event.index) this.slider.goTo(event.index);
        if (this.thumbnails.getInfo().index != event.index) this.thumbnails.goTo(event.index);
    }

    setIsMobile() {
        const originalThis = this;
        var timeout = false,
            delay = 500;
        window.addEventListener('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(originalThis.sliderCheck.setMobile(window.innerWidth <= 767), delay);
        });
        this.sliderCheck.setMobile(window.innerWidth <= 767);
    }

    thumbnailCheck() {
        this.sliderCheck = {
            isMobile: window.innerWidth < 768,
            setMobile(val) {
                if (val === this.isMobile) return;
                this.isMobile = val;
                this.mobileListener(val);
            },
            mobileListener: function (val) { },
            registerNewListener: function (externalListenerFunction) {
                this.mobileListener = externalListenerFunction;
            },
        };
        if (this.sliderCheck.isMobile) {
            this.slider = tns({
                ...this.config,
            });
        } else {
            this.slider = tns({
                ...this.config,
                navContainer: this.config.navElm,
                navAsThumbnails: this.config.hasNav,
                onInit: this.initThumbnails.bind(this),
            });
        }

        this.setIsMobile();
        this.sliderCheck.registerNewListener(() => window.location.reload());
    }

    goTo(id) {
        const slide = this.querySelector(id);
        this.slider.goTo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
    }

    onTransitionEnd(event) {
        if (this.directorButtons && this.directorButtons.length > 0) {
            this.directorButtons.forEach((button, i) => {
                event.index === i ? button.classList.add('button--active') : button.classList.remove('button--active');
            });
        } else if (this.config.sliderDirectorButtons && this.config.sliderDirectorButtons.length > 0) {
            this.config.sliderDirectorButtons.forEach((button, i) => {
                event.index === i ? button.classList.add('button--active') : button.classList.remove('button--active');
            });
        }
    }

    directorClick(event) {
        event.preventDefault();
        const thisButton = event.target;
        this.goTo(thisButton.dataset.attr);
    }
}

customElements.define('tiny-slider', TinySlider);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.isCard = this.closest('product-info').dataset.card === 'true';
        this.listOfOptions = null;
        this.availableAndOutOfStockOptions = null;
        this.listOfAvailableOptions = null;
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleLoading();
        this.removeErrorMessage();
        this.updateVariantStatuses(event.target.dataset.optionPosition);
        if (window.theme.settings.variantWarningEnable) this.updateStrengthWarning();
        document.dispatchEvent(
            new CustomEvent('variant:change', {
                detail: {
                    variant: this.currentVariant,
                },
            })
        );

        if (!this.currentVariant) {
            this.toggleLoading();
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    generateCardImage(image) {
        const cardImage = document.createElement('IMG');
        cardImage.src = image.preview_image.src;
        cardImage.dataset.id = image.id;
        return cardImage;
    }

    updateCardImage(cardContent, image) {
        cardContent.querySelectorAll('img').forEach((existingImage) => {
            existingImage.classList.add('hidden');
        });

        if (image) {
            const hasImage = cardContent.querySelector(`img[data-id="${image.id}"]`);
            if (hasImage) {
                hasImage.classList.remove('hidden');
            } else {
                cardContent.prepend(this.generateCardImage(this.currentVariant.featured_media));
            }
        } else {
            const defaultImage = cardContent.querySelector(`.card__media--default`);
            defaultImage.classList.remove('hidden');
        }
    }

    updateMedia() {
        if (!this.currentVariant) return;

        const cardContent = document.querySelector(`#ProductCard-${this.dataset.section} .card__media .media`);
        if (cardContent) this.updateCardImage(cardContent, this.currentVariant.featured_media);

        if (!this.currentVariant.featured_media) return;

        const srcArray = this.currentVariant.featured_media['preview_image'].src.split('/');
        const imageWithoutFileName = srcArray.slice(0, -1);
        const imageWithoutFileNameString = imageWithoutFileName.join('/');
        const fileNameString = srcArray[srcArray.length - 1].replace('.', '_250x250.');
        const imageSrc = imageWithoutFileNameString + '/' + fileNameString;

        if (document.querySelector('.product-drawer__wrapper .product__content-image img')) {
            document.querySelector('.product-drawer__wrapper .product__content-image img')?.remove();
            document.querySelector('.product-drawer__wrapper .product__content-image').innerHTML = `
            <img
                src="${imageSrc}"
                alt="${this.currentVariant.featured_media.alt ? this.currentVariant.featured_media.alt : ''}"
                width="100"
                height="100"
            />`;
        }

        const mediaGalleries = document.querySelectorAll(`[id^="GalleryViewer-${this.dataset.section}"]`);
        mediaGalleries.forEach((mediaGallery) => {
            mediaGallery.goTo(`div[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateStrength(callback) {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #quick-add-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const productFormTag = productForm.parentElement;
            let strengthIndex = null;

            if (productFormTag.dataset.analyticsStrengthIndex) {
                strengthIndex = parseInt(productFormTag.dataset.analyticsStrengthIndex);
            }

            console.log(strengthIndex);

            callback(productFormTag, this.currentVariant.options[strengthIndex]);
        });
    }

    updateVariantInput() {
        this.updateStrength((productFormTag, strength) => {
            productFormTag.dataset.analyticsStrength = strength;
            productFormTag.dataset.analyticsVariant = this.currentVariant.title;

            const input = productFormTag.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateOptionStatus(option, inputWrappers, index) {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
        const availableAndOutOfStockOptionInputsValue = selectedOptionOneVariants.map(
            (variantOption) => variantOption[`option${index + 1}`]
        );

        this.listOfOptions = optionInputs;
        this.listOfAvailableOptions = availableOptionInputsValue;
        this.availableAndOutOfStockOptions = availableAndOutOfStockOptionInputsValue;
    }

    updateVariantStatuses(changedPosition) {
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];

        inputWrappers.forEach((option, index) => {
            if (index === 0) return;

            this.updateOptionStatus(option, inputWrappers, index);
            this.setInputAvailability();
            if (parseInt(changedPosition) === 1) this.triggerChange();
        });

        if (parseInt(changedPosition) === 1) this.dispatchEvent(new Event('change'));
    }

    setInputAvailability() {
        this.listOfOptions.forEach((input) => {
            if (this.availableAndOutOfStockOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace(
                    '[value]',
                    input.getAttribute('value')
                );
            }
        });
    }

    renderStrengthWarning() {
        const warning = document.createElement('DIV');
        warning.classList.add('variant-warning');
        warning.innerHTML = window.productStrings.variantWarning;
        return warning;
    }

    updateStrengthWarning() {
        this.updateStrength((productFormTag, strength) => {
            const strengthInt = parseInt(strength);
            const currentWarning = this.querySelector('.variant-warning');

            if (strengthInt < 14) {
                if (currentWarning) currentWarning.remove();
                return;
            }

            const warning = this.renderStrengthWarning();
            const strengthSelector = this.querySelector('.label--strength').closest(
                '.product-variant-options__wrapper'
            );

            if (!currentWarning) strengthSelector.parentNode.insertBefore(warning, strengthSelector.nextSibling);
        });
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const isCard = this.isCard;
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const fetchURL = isCard
            ? `${this.dataset.url}?variant=${requestedVariantId}&view=card`
            : `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`;

        fetch(fetchURL)
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const rawHtml = new DOMParser().parseFromString(responseText, 'text/html');
                const html = rawHtml;
                const sourceSectionId = isCard
                    ? rawHtml.querySelector('product-info').getAttribute('data-section')
                    : sectionId;

                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${sourceSectionId}`);
                const drawerDescriptionSource = html.getElementById(`drawer-description-${sourceSectionId}`);
                const drawerDescriptionDestination = document.getElementById(
                    `drawer-description-${this.dataset.section}`
                );
                const subscriptionSource = html.getElementById(`subscription-${sourceSectionId}`);
                const subscriptionDestination = document.getElementById(`subscription-${this.dataset.section}`);
                const reviewsSource = html.querySelectorAll(`.js-reviews-${sourceSectionId}`);
                const reviewsDestination = document.querySelectorAll(`.js-reviews-${this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (subscriptionSource && subscriptionDestination)
                    subscriptionDestination.innerHTML = subscriptionSource.innerHTML;
                if (drawerDescriptionSource && drawerDescriptionDestination) {
                    drawerDescriptionDestination.innerHTML = drawerDescriptionSource.innerHTML;
                    drawerDescriptionDestination.classList.remove('hidden');
                }
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
                }
                if (reviewsSource && reviewsDestination) {
                    reviewsSource.forEach((source, index) => {
                        reviewsDestination[index].innerHTML = source.innerHTML;
                    });
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination)
                    inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sourceSectionId}`)
                    ? html.getElementById(`ProductSubmitButton-${sourceSectionId}`)
                    : html.getElementById(`ProductSubmitButton-${sourceSectionId}__${this.dataset.id}`);

                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );
                this.toggleLoading();

                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    toggleLoading() {
        const productForm = document.getElementById(`ProductInfo-${this.dataset.section}`)
            ? document.getElementById(`ProductInfo-${this.dataset.section}`)
            : document.getElementById(`quick-add-${this.dataset.section}`);
        if (!productForm) return;
        const productCard = productForm.closest('.card');

        productCard
            ? productCard.classList.toggle('card--loading')
            : productForm.classList.toggle('product__info-container--loading');
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`)
            ? document.getElementById(`product-form-${this.dataset.section}`)
            : document.getElementById(`quick-add-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const drawerDescription = document.getElementById(`drawer-description-${this.dataset.section}`);
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (drawerDescription) drawerDescription.classList.add('hidden');

        if (!addButton) return;
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    isAvailable(value) {
        const isOutOfStock =
            this.availableAndOutOfStockOptions.includes(value) && !this.listOfAvailableOptions.includes(value);

        return {
            stock: isOutOfStock,
            status: !(isOutOfStock || !this.listOfAvailableOptions.includes(value)),
        };
    }

    setInputAvailability() {
        this.listOfOptions.forEach((input) => {
            const inputLabel = input.nextElementSibling;
            const available = this.isAvailable(input.getAttribute('value'));

            if (available.stock) {
                input.classList.add('disabled');
                input.classList.remove('hidden');
                inputLabel.classList.remove('hidden');
            } else if (!this.listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.add('hidden');
                inputLabel.classList.add('hidden');
                input.classList.remove('disabled');
            } else {
                input.classList.remove('disabled');
                input.classList.remove('hidden');
                inputLabel.classList.remove('hidden');
            }
        });
    }

    requiresChange() {
        let firstAvailable = this.listOfOptions.find((input) => this.isAvailable(input.getAttribute('value')).status);
        const selectedOption = this.listOfOptions.find((input) => input.checked);
        if (firstAvailable === undefined)
            firstAvailable = this.listOfOptions.find((input) => input.value == this.availableAndOutOfStockOptions[0]);

        return {
            firstAvailable: firstAvailable,
            selectedOption: selectedOption,
            required: selectedOption != firstAvailable && this.listOfAvailableOptions.length > 0,
        };
    }

    triggerChange() {
        const changeCheck = this.requiresChange();
        if (changeCheck.selectedOption != changeCheck.firstAvailable) {
            if (changeCheck.firstAvailable) {
                changeCheck.firstAvailable.checked = true;
            } else {
                this.listOfOptions[0].checked = true;
            }
        }
    }

    updateOptions() {
        const selectedValues = this.querySelectorAll('.product-form__input-active');
        if (!selectedValues) return;
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset, index) => {
            if (selectedValues[index])
                selectedValues[index].textContent = Array.from(fieldset.querySelectorAll('input')).find(
                    (radio) => radio.checked
                ).value;

            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.fetchRecommendations((response) => {
            const html = document.createElement('div');
            html.innerHTML = response;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                if (this.querySelector('.tiny-slider__slides')) {
                    this.config = new TinySliderConfig().generateConfig(this);
                    this.slider = tns(this.config);
                    if (document.querySelector('quick-add-drawer')) {
                        document.querySelector('quick-add-drawer').setQuickAddLinkClicks();
                    }
                }
            }
            this.querySelector('.related-products').classList.remove('related-products--loading');
        });
    }

    async fetchRecommendations(callback) {
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((response) => {
                callback(response);
            })
            .catch((e) => {
                console.error(e);
            });
    }
}

customElements.define('product-recommendations', ProductRecommendations);

// todo: Add the form validation here
class FormValidation extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleValidation.bind(this));
        this.inputs = this.querySelectorAll('input, select');
        this.formError = this.querySelector('.global-message--error');
        this.formErrorContent = this.querySelector('.global-message--error .global-message__copy');
        this.hasValidated = false;
        this.validationStatus = [];
        this.inputEvents = [];

        this.inputs.forEach((input) => {
            if (input.readOnly || !input.required || this.checkPhoneEligibility(input)) return;
            if (input.getAttribute('type') === 'checkbox') input.checked = false;
            const inputValidation = this.validationCheck(input);
            const changeFunction = this.inputChange.bind(this);

            this.validationStatus.push({
                input: input,
                status: inputValidation.status,
            });
            this.inputEvents.push({
                input: input,
                function: changeFunction,
            });
            input.addEventListener('input', changeFunction);
        });

        this.addEventListener('form-validation:add-input', (event) => {
            this.addValidationAndListeners(event.detail.input);
        });
        this.addEventListener('form-validation:remove-input', (event) => {
            this.removeValidationAndListeners(event.detail.input);
        });

        this.toggleManualAddress = this.querySelector('.js-address-manual');
        if (this.toggleManualAddress) this.toggleManualAddress.addEventListener('click', this.toggleAddress.bind(this));
    }

    toggleAddress(event) {
        event.preventDefault();

        const quickAddressDiv = this.querySelector('.form-field__container-quick-address');
        const quickAddressInput = quickAddressDiv.querySelector('input');
        if (quickAddressDiv) {
            quickAddressDiv.classList.add('hidden');
            this.removeValidationAndListeners(quickAddressInput);
        }

        const addressFieldsDiv = document.querySelector('.address-fields');
        if (addressFieldsDiv) {
            addressFieldsDiv.classList.remove('hidden');
        }
        return;
    }

    checkPhoneEligibility(input) {
        if (input.getAttribute('type') !== 'tel') return false;

        const togglePhoneCheckbox = this.querySelector('input[name="no_phone_number"]');

        if (togglePhoneCheckbox && !this.togglePhoneCheckboxInitialized) {
            togglePhoneCheckbox.addEventListener('change', () => this.togglePhoneCheck(togglePhoneCheckbox));
            this.togglePhoneCheckboxInitialized = true;
        }

        input.readOnly = togglePhoneCheckbox?.checked || false;
        return togglePhoneCheckbox?.checked || false;
    }

    togglePhoneCheck(checkbox) {
        this.querySelectorAll('input[type="tel"]').forEach((input) => {
            input.readOnly = checkbox.checked;

            if (checkbox.checked) {
                input.value = '';
                this.removeError(input);
                this.removeValidationAndListeners(input);
            } else {
                this.addValidationAndListeners(input);
            }
        });
    }

    removeValidationAndListeners(input) {
        const eventIndex = this.inputEvents.findIndex((event) => event.input === input);
        if (eventIndex !== -1) {
            input.removeEventListener('input', this.inputEvents[eventIndex].function);
            this.inputEvents.splice(eventIndex, 1);
        }
        const validationIndex = this.validationStatus.findIndex((validation) => validation.input === input);
        if (validationIndex !== -1) {
            this.validationStatus.splice(validationIndex, 1);
        }
    }

    addValidationAndListeners(input) {
        if (
            this.validationStatus.filter((status) => status.input === input).length > 0 &&
            this.inputEvents.filter((event) => event.input === input).length > 0
        ) {
            this.removeValidationAndListeners(input);
        }
        const changeFunction = this.inputChange.bind(this);
        const inputValidation = this.validationCheck(input);
        this.validationStatus.push({ input: input, status: inputValidation.status });
        this.inputEvents.push({ input: input, function: changeFunction });
        input.addEventListener('input', changeFunction);
    }

    renderErrorMessage(container, errorString) {
        const existingMessage = container.querySelector('.form-field__message--error');
        const newErrorMessage = errorString ?? window.validationStrings.required;
        if (existingMessage && existingMessage.textContent === newErrorMessage) return;

        existingMessage?.remove();
        const errorMessage = document.createElement('DIV');

        errorMessage.classList.add(...['form-field__message', 'form-field__message--error']);
        errorMessage.textContent = newErrorMessage;

        if (container.querySelector('.form-field__footer')) {
            container.querySelector('.form-field__footer').prepend(errorMessage);
        } else {
            container.append(errorMessage);
        }
    }

    removeError(input) {
        if (input.getAttribute('type') === 'checkbox') {
            this.validationStatus.forEach((part) => {
                if (part.input.getAttribute('name') === input.getAttribute('name')) part.status = true;
            });
        } else {
            this.validationStatus.find((part) => part.input === input).status = true;
        }

        // Removal of attribute only works on a timeout
        setTimeout(() => {
            const container = input.closest('.form-field__container');
            container.querySelector('.form-field__message--error')?.remove();
            container.classList.remove('form-field--error');
        });
    }

    flagError(input, errorMessage) {
        if (input.getAttribute('type') === 'checkbox') {
            this.validationStatus.forEach((part) => {
                if (part.input.getAttribute('name') === input.getAttribute('name')) part.status = false;
            });
        } else {
            this.validationStatus.find((part) => part.input === input).status = false;
        }

        const container = input.closest('.form-field__container');
        this.renderErrorMessage(container, errorMessage);
        container.classList.add('form-field--error');
    }

    validateMinMax(input) {
        const min = parseInt(input.getAttribute('min')) || undefined;
        const max = parseInt(input.getAttribute('max')) || undefined;
        const length = input.value.length;

        return {
            status: (min === undefined || length >= min) && (max === undefined || length <= max),
            min: min === undefined || length >= min,
            max: max === undefined || length <= max,
        };
    }

    emailValidate(input) {
        const value = input.value;
        const length = value.length;
        const re = /^[A-zÀ-ú0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const isEmail = re.test(value);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (length > this.validation.length.email) {
                return window.validationStrings.max_length.generic.replace(
                    '{{ length }}',
                    this.validation.length.email
                );
            } else if (!isEmail) {
                return window.validationStrings.invalid.email;
            }
        };

        if (length <= 0 || !isEmail || length > this.validation.length.email) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    phoneValidate(input) {
        const value = input.value.startsWith(this.validation.phone.prefix)
            ? input.value
            : `${this.validation.phone.prefix}${input.value}`;
        const length = value.length;
        const re = new RegExp(this.validation.phone.regex);
        const isPhone = re.test(value);

        const getErrorMessage = () => {
            if (length < this.validation.phone.min) {
                return window.validationStrings.min_length.replace('{{ length }}', this.validation.phone.min);
            } else if (length > this.validation.phone.max) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', this.validation.phone.max);
            } else if (!isPhone) {
                return window.validationStrings.invalid.phone;
            }
        };

        if (length < this.validation.phone.min || length > this.validation.phone.max || !isPhone) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    isOldEnough(value) {
        const getAge = (birthDate) => {
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        };

        var parts = value.split('/');

        var day = parseInt(parts[0]);
        var month = parseInt(parts[1]) - 1; // Month starts from 0 (January is 0)
        var year = parseInt(parts[2]);

        // Create a Date object for the entered date
        var enteredDate = new Date(year, month, day);
        const age = getAge(enteredDate);

        if (isNaN(age)) return false;

        return {
            state: age >= 18 && age < 100,
            age,
        };
    }

    dobValidate(input) {
        const value = input.value.split('-').reverse().join('/');
        const re = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
        const isDate = re.test(value);
        const isOldEnough = this.isOldEnough(value);

        const getErrorMessage = () => {
            if (!isDate) {
                return window.validationStrings.invalid.dob;
            } else if (!isOldEnough.state) {
                if (isOldEnough.age > 100) {
                    return window.validationStrings.invalid.dob_over_age;
                } else if (isOldEnough.age <= 0) {
                    return window.validationStrings.invalid.dob_future_age;
                } else {
                    return window.validationStrings.invalid.dob_inelegible;
                }
            }
        };

        if (!isDate || !isOldEnough.state) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    textValidate(input) {
        const isCorrectLength = this.validateMinMax(input);

        const getErrorMessage = () => {
            if (!isCorrectLength.max) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', input.getAttribute('max'));
            } else if (!isCorrectLength.min) {
                return window.validationStrings.min_length.replace('{{ length }}', input.getAttribute('min'));
            }
        };

        if (!isCorrectLength.status || input.value.length <= 0) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    postcodeValidate(input) {
        const value = input.value;
        const lengthSpaces = value.replace(/ /g, '');
        const length = lengthSpaces.length;
        const re = new RegExp(this.validation.postcode.regex);
        const isPostcode = re.test(value);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (length > this.validation.postcode.max) {
                return window.validationStrings.max_length.postcode;
            } else if (!isPostcode) {
                return window.validationStrings.invalid.postcode;
            }
        };

        if (length <= 0 || length > this.validation.postcode.max || !isPostcode) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    selectValidate(input) {
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0 || value === '---') {
                return window.validationStrings.required;
            }
        };

        if (length <= 0 || value === '---') {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    checkboxValidate(input) {
        const inputName = input.getAttribute('name');
        const allCheckbox = this.querySelectorAll(`input[type="checkbox"][name="${inputName}"]`);
        const isChecked = Array.from(allCheckbox).filter((checkbox) => checkbox.checked).length > 0;

        if (!isChecked) {
            return {
                status: false,
                message: null,
            };
        } else {
            return {
                status: true,
            };
        }
    }

    addressValidate(input) {
        const inputName = input.getAttribute('name').split('[')[1].split(']')[0];
        const value = input.value;
        const length = value.length;
        const maxLength = this.validation.length[inputName] ?? undefined;

        const getErrorMessage = () => {
            if (length > maxLength ?? false) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', maxLength);
            } else {
                return window.validationStrings.required;
            }
        };

        if (length <= 0 || (length > maxLength ?? false)) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    passwordComplianceValidation(value) {
        let compliant = 0;
        if (value.length < 8) compliant = 0;
        else {
            let expressions = [/[a-z]+/, /[0-9]+/, /[A-Z]+/, /[!@£#$%^&()<>_=+\-]+/];
            expressions.forEach((expression) => {
                if (value.match(expression)) compliant++;
            });
        }
        return compliant >= 3;
    }

    passwordValidate(input) {
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            }
        };

        if (length <= 0) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    generateStrengthIndicator(input) {
        let strength = 0;
        const container = input.closest('.form-field__container');
        // const label = container.querySelector('.strength-label');
        const label_value = container.querySelector('.strength-label span');
        const validator = container.querySelector('.strength-indicator');
        const value = input.value;
        const isCompliant = this.passwordComplianceValidation(value);
        const expressions = [/.{8,}/, /[a-z]+/, /[0-9]+/, /[A-Z]+/, /.{12,}/, /[!@£#$%^&()<>_=+\-]+/];

        expressions.forEach((regexp) => {
            if (value.match(regexp)) strength++;
        });

        if (value.length > 0) {
            if (strength >= 4 && isCompliant) {
                label_value.textContent = window.validationStrings.strength.strong;
                label_value.classList.remove('strength-label__value--weak');
                label_value.classList.add('strength-label__value--strong');
            } else {
                label_value.textContent = window.validationStrings.strength.weak;
                label_value.classList.remove('strength-label__value--strong');
                label_value.classList.add('strength-label__value--weak');
            }

            value.length >= 8
                ? validator
                    .querySelector('.strength-indicator__item--chars')
                    .classList.add('strength-indicator__item--active')
                : validator
                    .querySelector('.strength-indicator__item--chars')
                    .classList.remove('strength-indicator__item--active');
            value.match(/[a-z]+/)
                ? validator
                    .querySelector('.strength-indicator__item--lower')
                    .classList.add('strength-indicator__item--active')
                : validator
                    .querySelector('.strength-indicator__item--lower')
                    .classList.remove('strength-indicator__item--active');
            value.match(/[A-Z]+/)
                ? validator
                    .querySelector('.strength-indicator__item--upper')
                    .classList.add('strength-indicator__item--active')
                : validator
                    .querySelector('.strength-indicator__item--upper')
                    .classList.remove('strength-indicator__item--active');
            value.match(/[0-9]+/)
                ? validator
                    .querySelector('.strength-indicator__item--numbers')
                    .classList.add('strength-indicator__item--active')
                : validator
                    .querySelector('.strength-indicator__item--numbers')
                    .classList.remove('strength-indicator__item--active');
            value.match(/[!@£#$%^&()<>_=+\-]+/)
                ? validator
                    .querySelector('.strength-indicator__item--special')
                    .classList.add('strength-indicator__item--active')
                : validator
                    .querySelector('.strength-indicator__item--special')
                    .classList.remove('strength-indicator__item--active');
        }
        if (strength >= 4 && isCompliant) {
            validator.classList.add('hidden');
        } else {
            validator.classList.remove('hidden');
        }
    }

    password(input) {
        const container = input.closest('.form-field__container');
        const value = input.value;
        const length = value.length;
        const isCompliant = this.passwordComplianceValidation(value);

        if (container.querySelectorAll('.strength-indicator').length > 0) this.generateStrengthIndicator(input);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (!isCompliant) {
                return '';
            }
        };

        if (length <= 0 || !isCompliant) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    confirm(input) {
        const passwordField = this.validationStatus.find(
            (validation) => validation.input.getAttribute('name') === 'customer[password]'
        );
        const passwordFieldValue = passwordField.input.value;
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (passwordFieldValue != value) {
                return window.validationStrings.passwords_no_match;
            }
        };

        if (length <= 0 || passwordFieldValue != value) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    confirmPasswordValidate(input) {
        const isConfirm = input.getAttribute('name') === 'customer[password_confirmation]';
        return isConfirm ? this.confirm(input) : this.password(input);
    }

    validationCheck(input) {
        const passwordValid = () => {
            if (
                this.validationStatus.find(
                    (validation) => validation.input.getAttribute('name') === 'customer[password_confirmation]'
                )
            ) {
                return this.confirmPasswordValidate(input);
            } else {
                return this.passwordValidate(input);
            }
        };

        let inputType = input.getAttribute('type');
        const inputName = input.getAttribute('name');
        if (!inputType && input.tagName === 'SELECT') inputType = 'select';

        if (inputName == 'customer[password]' || inputName == 'customer[password_confirmation]')
            return passwordValid(input);

        switch (inputType) {
            case 'text':
                switch (inputName) {
                    case 'dob':
                        return this.dobValidate(input);
                    case 'address[zip]':
                        return this.postcodeValidate(input);
                    default:
                        if (inputName?.includes('address[')) {
                            return this.addressValidate(input);
                        } else {
                            return this.textValidate(input);
                        }
                }
            case 'email':
                return this.emailValidate(input);
            case 'tel':
                return this.phoneValidate(input);
            case 'password':
                return passwordValid(input);
            case 'checkbox':
                return this.checkboxValidate(input);
            case 'select':
                switch (inputName) {
                    case 'address[country]':
                    case 'address[province]':
                        return this.selectValidate(input);
                }
        }

        return {
            status: false,
            message: null,
        };
    }

    flagInput(validation, input) {
        if (validation.status) {
            this.removeError(input);
        } else {
            this.flagError(input, validation.message);
        }
    }

    inputChange(event) {
        if (!event.target.required) return;
        const inputValidation = this.validationCheck(event.target);
        this.flagInput(inputValidation, event.target);
    }

    triggerFormError() {
        if (!this.formError) return;
        this.formError.classList.add('global-message--active');
        this.formErrorContent.textContent = window.validationStrings.generic;
    }

    removeFormError() {
        if (!this.formError) return;
        this.formError.classList.remove('global-message--active');
    }

    handleValidation(event) {
        event.preventDefault();
        const failedFields = this.validationStatus.filter((part) => part.status === false);
        if (failedFields.length > 0) {
            this.hasValidated = false;
            this.triggerFormError();
            failedFields.forEach((validation) => this.flagInput(validation, validation.input));
        } else {
            this.hasValidated = true;
            this.removeFormError();
        }
    }
}

customElements.define('form-validation', FormValidation);

class PhoneField extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.prefixElement = this.querySelector('.form-field__prefix');
        this.inputElement = this.querySelector('.form-field__input');
    }

    connectedCallback() {
        this.prefixElement.textContent = this.validation.phone.prefix;
        this.removePrefixFromExistingValue();
    }

    removePrefixFromExistingValue() {
        if (this.inputElement.value.startsWith(this.validation.phone.prefix)) {
            this.inputElement.value = this.inputElement.value.replace(this.validation.phone.prefix, '');
        }
    }
}

customElements.define('phone-field', PhoneField);

class InputCounter extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.input = this.querySelector('input');
        this.inputName = this.input.getAttribute('name').split('[')[1].split(']')[0];
        this.maxLength = this.validation.length[this.inputName] ?? undefined;
        this.container = this.querySelector('.form-field-counter');
        this.current = this.querySelector('.form-field-counter__current');
        this.max = this.querySelector('.form-field-counter__max');

        this.input.addEventListener('input', this.updateCounter.bind(this));
        this.input.addEventListener('keypress', this.preventType.bind(this));
    }

    connectedCallback() {
        if (!this.maxLength) return;

        if (this.container) this.container.classList.remove('hidden');
        if (this.current) this.current.textContent = this.input.value.length;
        if (this.max) this.max.textContent = this.maxLength;
    }

    preventType(event) {
        if (event.target.value.length >= this.maxLength) event.preventDefault();
    }

    updateCounter() {
        const value = this.input.value;
        const length = value.length;

        if (this.current) this.current.textContent = length;
    }
}

customElements.define('input-counter', InputCounter);

class CountryProvinceField extends HTMLElement {
    constructor() {
        super();
        this.country = this.querySelector('select[name="address[country]"]');
        this.province = this.querySelector('select[name="address[province]"]');

        this.country.value = window.validation.country;
        this.country.addEventListener('input', this.renderProvinces.bind(this));

        this.renderCountry();
        this.renderProvinces();
    }

    renderCountry() {
        const opts = this.country.querySelectorAll('option');
        let defaultProvince = this.country.dataset.default ? this.country.dataset.default : [...opts][0].value;

        const options = [...opts].map((opt) => opt.value);
        const defaultOption = options.indexOf(defaultProvince);
        if (!opts[defaultOption]) return;
        opts[defaultOption].setAttribute('selected', 'selected');
        this.dispatchEvent(
            new CustomEvent('form-validation:add-input', {
                bubbles: true,
                detail: {
                    input: this.country,
                },
            })
        );
    }

    renderProvinces() {
        const opt = this.country.querySelectorAll('option')[this.country.selectedIndex];
        const defaultProvince = this.province.dataset.default;
        if (!opt) return;

        const raw = opt.getAttribute('data-provinces');
        const provinces = JSON.parse(raw);
        while (this.province.firstChild) {
            this.province.removeChild(this.province.firstChild);
        }

        if (provinces.length) {
            this.province.closest('.form-field__container').classList.remove('hidden');
            this.province.removeAttribute('disabled');
            this.province.setAttribute('required', 'required');
            const province_default_opt = document.createElement('option');
            province_default_opt.value = '---';
            province_default_opt.textContent = '---';
            if (!defaultProvince) province_default_opt.setAttribute('selected', 'selected');
            this.province.append(province_default_opt);
            for (var i = 0; i < provinces.length; i++) {
                const province_opt = document.createElement('option');
                province_opt.value = provinces[i][0];
                province_opt.textContent = provinces[i][1];
                if (provinces[i][0] === defaultProvince) province_opt.setAttribute('selected', 'selected');
                this.province.append(province_opt);
            }

            this.dispatchEvent(
                new CustomEvent('form-validation:add-input', {
                    bubbles: true,
                    detail: {
                        input: this.province,
                    },
                })
            );
        } else {
            this.province.closest('.form-field__container').classList.add('hidden');
            this.province.setAttribute('disabled', 'disabled');
            this.province.removeAttribute('required');

            this.dispatchEvent(
                new CustomEvent('form-validation:remove-input', {
                    bubbles: true,
                    detail: {
                        input: this.province,
                    },
                })
            );
        }
    }
}

customElements.define('country-province-field', CountryProvinceField);

class DOBField extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.input.addEventListener('keydown', this.forceNumeric.bind(this));
        this.input.addEventListener('keyup', this.forceFormatting.bind(this));
    }

    forceNumeric(event) {
        if (
            (isNaN(event.key) || dateValue.length >= 10) &&
            !['Enter', 'Backspace', 'Delete', 'Shift', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)
        ) {
            event.preventDefault();
        }
    }

    forceFormatting(event) {
        let dateValue = this.input.value;
        if (dateValue.length === 3 && dateValue.charAt(2) !== '/')
            this.input.value = dateValue.slice(0, 2) + '/' + dateValue.slice(2);
        if (dateValue.length === 6 && dateValue.charAt(5) !== '/')
            this.input.value = dateValue.slice(0, 5) + '/' + dateValue.slice(5);
    }
}

customElements.define('dob-field', DOBField);

class PasswordField extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.input = this.querySelector('input');
        this.hiddenIcon = this.querySelector('.password-field__hidden');
        this.visibleIcon = this.querySelector('.password-field__visible');
        this.button.addEventListener('click', this.toggleVisibility.bind(this));
    }

    toggleIcon() {
        if (!this.hiddenIcon || !this.visibleIcon) return;
        this.hiddenIcon.classList.toggle('hidden');
        this.visibleIcon.classList.toggle('hidden');
    }

    toggleVisibility(event) {
        event.preventDefault();
        this.input.setAttribute('type', this.input.getAttribute('type') === 'password' ? 'text' : 'password');
        this.toggleIcon();
    }
}

customElements.define('password-field', PasswordField);

class SubscriptionInfo extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleSubscriptionModal.bind(this));
    }

    toggleSubscriptionModal(event) {
        event.preventDefault();
        const tiers = this.button.dataset.subscriptionItems ? this.button.dataset.subscriptionItems.split(', ') : null;
        document.dispatchEvent(
            new CustomEvent('modal:open', {
                detail: {
                    modal: '.understanding-subs-modal',
                    tiers: tiers,
                },
            })
        );
    }
}

customElements.define('subscription-info', SubscriptionInfo);

class SubscriptionModule extends HTMLElement {
    constructor() {
        super();
        this.select = this.querySelector('select[name="properties[_subscription]"]');
        this.checkbox = this.querySelector('input[name="subscription-toggle"]');
        this.settingsTemplate = this.querySelector('script[type="text/template"]');
        this.settings = this.settingsTemplate ? JSON.parse(this.settingsTemplate.innerHTML) : undefined;

        if (this.checkbox) this.checkbox.addEventListener('change', this.subscriptionChange.bind(this));
    }

    subscriptionChange(event) {
        const newValue = this.checkbox.checked ? 'true' : 'false';
        this.select.value = newValue;
        if (newValue === 'true')
            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.subscribeToggle, {
                ...this.settings,
            });
    }
}

customElements.define('subscription-module', SubscriptionModule);

class MarketingField extends HTMLElement {
    constructor() {
        super();
        this.inputs = this.querySelectorAll('input');
        this.accountDrawer = document.querySelector('account-drawer');
    }

    connectedCallback() {
        this.fetchCustomerConsent();
    }

    toggleInput(data) {
        if (data.ok) {
            this.inputs.forEach((input) => {
                input.checked =
                    input.name === 'customer[accepts_marketing]'
                        ? data.emailMarketingConsent === 'SUBSCRIBED' || data.emailMarketingConsent === 'true'
                        : data.smsMarketingConsent === 'SUBSCRIBED' || data.smsMarketingConsent === 'true';
            });
        }
    }

    fetchCustomerConsent() {
        const shopify_customer_id = window.customerVariables.customerID;
        if (!shopify_customer_id) {
            return;
        }
        if (this.accountDrawer) this.accountDrawer.toggleLoading();

        fetch(getGlobalDomain('/apps/bat-enhanced/customer'))
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(this.toggleInput.bind(this))
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                if (this.accountDrawer) this.accountDrawer.toggleLoading();
            });
    }
}

customElements.define('current-marketing-fields', MarketingField);

// Live Chat Widget Code.

if (window.platformScripts.isLiveChat) {
    const contactUs = {
        liveChatButton: '#chat_button',
        liveChatWidget: '.embeddedServiceHelpButton button.helpButtonEnabled',
        init: function () {
            this.checkLiveChatStatus();
        },
        checkIcon: function (callback) {
            let loopCount = 0;
            const chatCheck = setInterval(() => {
                if (!document.querySelector(this.liveChatWidget) && loopCount <= 5) {
                    loopCount++;
                } else {
                    clearInterval(chatCheck);
                    callback(loopCount > 5 ? false : true);
                }
            }, 1000);
        },
        checkLiveChatStatus: function () {
            const button = document.querySelector(this.liveChatButton);
            if (button) {
                this.checkIcon((response) => {
                    if (response) {
                        button.textContent = window.accessibilityStrings.chat.onlineStatus;
                        button.removeAttribute('disabled');

                        button.addEventListener('click', (event) => {
                            event.preventDefault();
                            const widget = document.querySelector(this.liveChatWidget);
                            if (widget) {
                                widget.click();
                            }
                        });
                    } else {
                        button.textContent = window.accessibilityStrings.chat.offlineStatus;
                    }
                });
            }
        },
    };

    document.addEventListener('DOMContentLoaded', function () {
        contactUs.init();
    });
}

class LoginForm extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.error = this.querySelector('.global-message');
        this.errorContent = this.querySelector('.global-message__copy');
        this.loadingSpinner = this.querySelector('.generic-form__spinner');

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    connectedCallback() {
        this.checkLoggedOut();
    }

    formSubmit() {
        if (!this.hasValidated) return;
        this.handleLoginValidation();
    }

    showLoadingState() {
        if (!this.loadingSpinner) return;
        this.loadingSpinner.classList.remove('hidden');
    }

    hideLoadingState() {
        if (!this.loadingSpinner) return;
        this.loadingSpinner.classList.add('hidden');
    }

    generateErrorMessage() {
        const locales = window.loginSidebarStrings.loginErrorMsg;
        const errorMessage = document.createElement('SPAN');
        const errorLink = document.createElement('A');
        errorLink.href = getGlobalDomain(locales.partLink);
        errorLink.textContent = locales.partTwo;
        errorMessage.append(`${locales.partOne} `, errorLink, ` ${locales.partThree}`);
        return errorMessage;
    }

    displayLoginError(networkError = false) {
        this.errorContent.innerHTML = '';
        if (networkError) {
            this.errorContent.innerHTML = window.loginSidebarStrings.networkErrorMsg;
        } else {
            this.errorContent.append(this.generateErrorMessage());
        }
        this.error.classList.add('global-message--active');
    }

    handleLoginCheck() {
        this.error.classList.remove('global-message--active');
        fetch(getGlobalDomain('/apps/bat-social/authenticate'), {
            method: 'POST',
            body: new URLSearchParams(new FormData(this.form)),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.ok) {
                    if (data?.token) {
                        fetch(getGlobalDomain('/account/login/multipass/') + data.token)
                            .then((response) => response.json())
                            .finally(() => {
                                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login);
                                fetch(getGlobalDomain('/cart/update')).finally(() => {
                                    const previousLogInUrl = window.location.href;
                                    if (previousLogInUrl.includes('cart')) {
                                        window.location.href = getGlobalDomain('/pages/checkout');
                                    } else {
                                        window.location.href = previousLogInUrl + '?logged-in=true';
                                    }
                                });
                            });
                        // window.location.href = getGlobalDomain("/account/login/multipass/") + data.token;
                    } else {
                        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login, {
                            failed: {
                                reason: 'incorrect_credentials',
                                fields: 'password',
                            },
                        });
                        this.hideLoadingState();
                        this.displayLoginError();
                    }
                } else {
                    this.hideLoadingState();
                    this.displayLoginError();
                    sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login, {
                        failed: {
                            reason: 'incorrect_credentials',
                            fields: 'password',
                        },
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                this.displayLoginError(true);
                this.hideLoadingState();
            });

        if (document.body.getAttribute('data-customer-invitation')) {
            document.removeEventListener('login:checked', this.handleLoginCheck, false);
        }
    }

    handleLoginValidation() {
        this.showLoadingState();

        if (document.body.getAttribute('data-customer-invitation')) {
            document.dispatchEvent(
                new CustomEvent('login:check', {
                    detail: {
                        form: this.form,
                    },
                })
            );

            document.addEventListener('login:checked', this.handleLoginCheck());
        } else {
            this.handleLoginCheck();
        }
    }
    checkLoggedOut() {
        const url = new URL(window.location.href);
        if (url.searchParams.get('logged-out')) {
            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.logout);
            history.replaceState(history.state, '', window.location.origin);
        }
    }
}

customElements.define('login-form', LoginForm);

class AddAddress extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');

        this.updateReturnToUrl();

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    updateReturnToUrl() {
        if (window.location.href.includes('/pages/checkout')) {
            const returnToInput = this.form.querySelector('input[name="return_to"]');
            if (returnToInput) {
                returnToInput.value = getGlobalDomain('/pages/checkout');
            }
        }
    }

    async submit(body) {
        fetch(this.form.getAttribute('action'), {
            method: 'POST',
            body,
        }).finally(() => window.location.reload());
    }

    formSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const phone = formData.get('address[phone]');

        if (phone != '' && !phone.startsWith(window.validation[Shopify.country].phone.prefix))
            formData.set('address[phone]', `${window.validation[Shopify.country].phone.prefix}${phone}`);

        if (!this.hasValidated) return;
        this.submit(formData);
    }
}

customElements.define('add-address', AddAddress);

class EditAddress extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');

        this.updateReturnToUrl();

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    updateReturnToUrl() {
        if (window.location.href.includes('/pages/checkout')) {
            const returnToInput = this.form.querySelector('input[name="return_to"]');
            if (returnToInput) {
                returnToInput.value = getGlobalDomain('/pages/checkout');
            }
        }
    }

    async submit(body) {
        fetch(this.form.getAttribute('action'), {
            method: 'POST',
            body,
        }).finally(() => window.location.reload());
    }

    formSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const phone = formData.get('address[phone]');

        if (phone != '' && !phone.startsWith(window.validation[Shopify.country].phone.prefix))
            formData.set('address[phone]', `${window.validation[Shopify.country].phone.prefix}${phone}`);

        if (!this.hasValidated) return;
        this.submit(formData);
    }
}

customElements.define('edit-address', EditAddress);

class QuickAddressFinder extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('add-address');
        this.quickAddressFinder = this.querySelector('input[name="quickAddressFinder"]');
        this.quickAddressFinderContainer = this.querySelector('.toggle-address__manually');
        this.addressFields = this.querySelector('.address-fields');

        this.fields = [
            {
                element: this.quickAddressFinder,
                field: '',
            },
            {
                element: this.querySelector('input[name="address[company]"]'),
                field: 'Company',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[company]"]'),
                field: 'BuildingNumber',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[address1]"]'),
                field: 'Line1',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[address2]"]'),
                field: 'Line2',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[city]"]'),
                field: 'City',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[province]"]'),
                field: 'Province',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[zip]"]'),
                field: 'PostalCode',
                mode: pca.fieldMode.POPULATE,
            },
        ];

        this.options = {
            key: window.platformScripts.api.loqate,
            search: { countries: Shopify.country },
            setCountryByIP: true,
        };

        this.control = new pca.Address(this.fields, this.options);
        this.control.listen('populate', this.populateAddresses.bind(this));
    }

    populateAddresses() {
        this.addressFields.classList.remove('hidden');
        this.quickAddressFinderContainer.classList.add('hidden');
        this.form.removeValidationAndListeners(this.quickAddressFinder);

        this.fields.forEach((field) => {
            if (!field.element) return;
            field.element.dispatchEvent(new Event('input'));
        });
    }
}

customElements.define('quick-address-finder', QuickAddressFinder);

function formatMoney(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);

    if (match) {
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
    }

    return formatString.replace(placeholderRegex, value);
}

class ToggleTabs extends HTMLElement {
    constructor() {
        super();
        this.toggles = this.querySelectorAll('.tabs__item');
        this.tabs = this.querySelectorAll('.tabs-content__item');
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', this.toggleItem.bind(this));
        });
    }

    toggleItem(event) {
        this.toggle = event.target;
        this.toggles.forEach((toggle) => {
            if (toggle === this.toggle) {
                toggle.classList.add('tabs__item--active');
            } else {
                toggle.classList.remove('tabs__item--active');
            }
            this.toggleContent();
        });
    }

    toggleContent() {
        this.toggleName = this.toggle.getAttribute('name');
        if (!this.toggleName) return;

        this.tabs.forEach((tab) => {
            this.tabAttr = tab.getAttribute('data-attr');
            if (!this.tabAttr) return;

            if (this.tabAttr === this.toggleName) {
                tab.classList.add('tabs-content__item--active');
            } else {
                tab.classList.remove('tabs-content__item--active');
            }
        });
    }
}

customElements.define('toggle-tabs', ToggleTabs);

class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.endTimeSetting = this.getAttribute('data-counter-end');
        this.hoursEl = this.querySelector('.time-loading--hours');
        this.minutesEl = this.querySelector('.time-loading--minutes');
        this.secondsEl = this.querySelector('.time-loading--seconds');

        if (!this.endTimeSetting) return;
        [this.endHour, this.endMinute] = this.endTimeSetting.split(':').map(Number);

        setInterval(this.updateCountdown.bind(this), 1000);
    }

    updateCountdown() {
        const now = new Date();
        let endOfDay = new Date();
        endOfDay.setHours(this.endHour, this.endMinute, 0);

        if (now > endOfDay) {
            endOfDay.setDate(now.getDate() + 1);
        }
        const diff = endOfDay - now;
        const hours = Math.floor(diff / 1000 / 60 / 60);
        const mins = Math.floor(diff / 1000 / 60) % 60;
        const secs = Math.floor(diff / 1000) % 60;

        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(mins).padStart(2, '0');
        this.secondsEl.textContent = String(secs).padStart(2, '0');

        [this.hoursEl, this.minutesEl, this.secondsEl].forEach((el) => {
            if (el.classList.contains('time-loading')) {
                el.classList.remove('time-loading');
            }
        });
    }
}
customElements.define('countdown-timer', CountdownTimer);

class NewsletterComponent extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.isCustomer = window.customerVariables.isCustomer;
        this.newsletter_triggers = this.querySelectorAll('.button--newsletter');
        this.newsletter_triggers.forEach((newsletter_trigger) => {
            newsletter_trigger.addEventListener('click', this.toggleModal.bind(this));
        });

        const floatingNewsletterPopupDismissed = sessionStorage.getItem('closeFloatingNewsletterPopup');
        if (floatingNewsletterPopupDismissed == null) {
            this.newsletter_floating_popup = this.querySelector('.newsletter__floating-popup');
            if (this.newsletter_floating_popup && newsletter_floating_popup_delay) {
                this.showFloatingPopup(newsletter_floating_popup_delay);
            }
            this.newsletter_floating_close = this.querySelector('.newsletter__floating-popup-close');
            if (this.newsletter_floating_close)
                this.newsletter_floating_close.addEventListener('click', this.closeFloatingPopup.bind(this));
        }
    }

    showFloatingPopup(delay) {
        setTimeout(() => {
            this.newsletter_floating_popup.classList.remove('hidden');
        }, parseInt(delay + '000'));
    }

    closeFloatingPopup() {
        this.newsletter_floating_popup.remove();
        sessionStorage.setItem('closeFloatingNewsletterPopup', 'true');
    }

    toggleModal(event) {
        event.preventDefault();
        if (this.isCustomer) {
            document.dispatchEvent(
                new CustomEvent('account:open', {
                    detail: {
                        tab: 'marketing-preferences',
                    },
                })
            );
        } else {
            this.newsletter_popup = document.querySelectorAll('#newsletter-popup, .newsletter-overlay');
            this.newsletter_popup.forEach((newsletter_popup) => {
                if (newsletter_popup.getAttribute('class').includes('active')) {
                    newsletter_popup.classList.remove('active');
                } else {
                    newsletter_popup.classList.add('active');
                }
            });
            document.body.classList.toggle('overflow-hidden');
        }
    }
}

customElements.define('newsletter-component', NewsletterComponent);

class ProductInfoDescription extends HTMLElement {
    constructor() {
        super();

        if (this.querySelector('.product-line-description-wrapper__header')) {
            this.querySelector('.product-line-description-wrapper__header').addEventListener(
                'click',
                this.openToggle.bind(this)
            );
        }
    }

    openToggle(event) {
        this.querySelector('.product-line-description-wrapper__content').classList.toggle(
            'product-line-description-wrapper__content--active'
        );
        this.querySelector('.product-line-description-wrapper__header-icons').classList.toggle(
            'product-line-description-wrapper__header-icons--active'
        );
    }
}

customElements.define('product-info-component', ProductInfoDescription);

// This is a necessary evil to do the mobile menu height including all announcement bars that have been added
document.addEventListener('DOMContentLoaded', () => {
    const headerGroupHeight = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
        .map((el) => el.clientHeight)
        .reduce((a, b) => a + b, 0);

    const headerStickyGroupHeight = Array.from(document.querySelectorAll('.shopify-section-header-sticky'))
        .map((el) => el.clientHeight)
        .reduce((a, b) => a + b, 0);

    const verifyBottomBar = document.querySelector('.fixed-verify-bar')
        ? document.querySelector('.fixed-verify-bar').clientHeight
        : 0;

    document.body.style.setProperty('--header-height', `${headerGroupHeight}px`);
    document.body.style.setProperty('--header-sticky-height', `${headerStickyGroupHeight}px`);
    document.body.style.setProperty('--verify-bar', `${verifyBottomBar}px`);
});

class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.toggleButtons = this.querySelectorAll('[name="localization"]');

        this.toggleButtons.forEach((button) =>
            button.addEventListener('click', this.handleLocalizationChange.bind(this))
        );
    }

    handleLocalizationChange(event) {
        event.preventDefault;
        const locale = event.target.value;
        if (!locale) return;
        const currentLocale = window.Shopify.routes.root.replaceAll('/', '');
        if (!currentLocale.includes('-')) return;
        const localeParts = currentLocale.split('-');
        const newLocale = locale + '-' + localeParts[1];
        window.location.href = window.location.href.replace(currentLocale, newLocale);
    }
}

customElements.define('localization-form', LocalizationForm);
